import React from 'react';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="about">
      <SEO
        title="Micropincher - Crypto analysis and trading simulation tool"
        description="Micropincher is analytical and trading simulation tool, for arbitrage strategies, funding fee trading, learning tool to prevent loss. Training tool to test your ability of profitable trading."
        ogImage="https://micropincher.com/images/og-image.jpg"
        ogUrl="https://micropincher.com/about"
        twitterImage="https://micropincher.com/images/og-image.jpg"
        canonicalUrl="https://micropincher.com/about"
      />
      <div className="about-content">
        <h1>About Micropincher</h1>
        <p>
          Micropincher is a modern application calculating opportunities from massive amount of data, connected tens of exchange platforms in crypto world.
        </p>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            We aim to create powerful tool to help us (and you) to find trading opportunities with minimal risk. The risk is minimized thanks to predictable profit from funding fees and thanks to hedging strategies preventing the loss from price moves.
          </p>
        </section>

        <section className="about-section">
          <h2>Technology Stack</h2>
          <ul className="tech-list">
            <li>React 18</li>
            <li>React Router</li>
            <li>Modern CSS</li>
            <li>ES6+ JavaScript</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default About;